import type { CommissionDetailDto } from '../types';

const formatCurrency = (amount: number) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);

interface SubcontractorPanelProps {
  commission: CommissionDetailDto;
}

export function SubcontractorPanel({ commission }: SubcontractorPanelProps) {
  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="px-2 py-1.5 border-b border-border bg-gray-50 rounded-t-lg">
        <h4 className="text-xs font-semibold">Subcontractor</h4>
      </div>
      <div className="p-2 space-y-1 text-xs">
        <div className="flex justify-between">
          <span className="text-muted-foreground">Name</span>
          <span className="font-medium">{commission.personName}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-muted-foreground">Rate</span>
          <span className="font-medium">{(commission.commissionRate * 100).toFixed(1)}%</span>
        </div>
        <div className="flex justify-between">
          <span className="text-muted-foreground">Balance</span>
          <span className="font-medium">{formatCurrency(commission.commissionAmount)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-muted-foreground">Total Paid</span>
          <span className="font-medium">{formatCurrency(commission.paidToDate)}</span>
        </div>
        <div className="flex justify-between pt-1 border-t border-border">
          <span className="font-semibold">Amount Due</span>
          <span className="font-bold">{formatCurrency(commission.amountDue)}</span>
        </div>
      </div>
    </div>
  );
}
